import models from "models/models";
import * as preact from "preact";

import * as modalDialog from "modalDialog";
import LanguageSelectorView from "views/LanguageSelectorView";
import * as walkthrough from "walkthrough";

/**
 * Display a modal dialog allowing the user to choose their first language and resolve the
 * returned promise once the user has selected and the choice has been saved to the user model.
 */
export const show = async () => {
  return new Promise<void>((resolve) => {
    modalDialog.showPreactComponent(
      preact.createElement(LanguageSelectorView, {
        languageType: "first",
        setLanguage: async (languageCode: string) => {
          await models.user.save(
            { firstLanguage: languageCode },
            { patch: true }
          );
          await walkthrough.setAchievement("setLanguages", true);
          modalDialog.cancel();
          resolve();
        },
      }),
      {
        heading: "Choose Your First Language",
        clickToCancel: true,
        closeButton: true,
        width: 300,
      }
    );
  });
};
